import { Record } from 'immutable';

export const SUBSCRIPTIONS_REDUCER_KEY = 'subscriptionsStore';

export const mkSubscription = Record({
  id: undefined,
  clientId: undefined,
  isDeleted: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  userModifiedAt: undefined,
  productLineName: undefined,
  productLineUriName: undefined,
  tierName: undefined,
  tierUriName: undefined,
  active: undefined,
  autoRenew: undefined,
  userId: undefined,
  effectiveAt: undefined,
  expireAt: undefined,
  expireOn: undefined,
  inactiveAt: undefined,
  updatingPaymentMethodWillAutorenew: undefined,
  supportedDatasetPlatforms: undefined,
  isInTrialPeriod: undefined,
  renewalFrequency: undefined,
  merchant: undefined,
  isInGracePeriod: undefined,
});
